import * as React from 'react';

import classnames from 'classnames';

import {KeyTriggeredAnimateIn} from '../../animation/key-triggered-animate-in';
import {colors} from '../../colors/colors';
import {Illustration} from '../../illustrations/illustration';
import {Stack} from '../../layout/stack/stack';

import {Orbs} from '../orbs/orbs';
import {AiHomepageDescription} from '../text/ai-homepage-description';
import {AiHomepageTitle} from '../text/ai-homepage-title';

import styles from './page-header.module.css';

type Props = {
    title: string;
    subTitle: string;
    illustration: string;
    accent: React.ComponentType<any> | React.ReactNode;
    navHeader?: React.ReactNode;
    action?: React.ReactNode;
};

export function PageHeader(props: Props) {
    const {accent: Accent} = props;

    const renderAccent = (): React.ReactElement | null => {
        // If it's a function (component), instantiate it with default props
        if (typeof Accent === 'function') {
            // @ts-expect-error
            return <Accent size={48} color={colors.aiPurplePrimary} />;
        } else if (typeof Accent === 'object' && React.isValidElement(Accent)) {
            return Accent;
        } else {
            return null;
        }
    };

    const contentContainerStyleNames = classnames(styles['content-container'], {
        [styles['content-container--has-nav-header']]: props.navHeader,
    });

    return (
        <Orbs
            config={[
                {top: 0, left: -10},
                {top: 0, left: 10},
                {top: 0, left: 40},
                {top: 0, left: 60},
                {top: 0, left: 80},
            ]}
        >
            <div className={styles.container}>
                <div className={contentContainerStyleNames}>
                    {/* @ts-expect-error */}
                    <KeyTriggeredAnimateIn triggerKey={props.title}>
                        {props.navHeader ? (
                            <div className={styles['nav-header']}>{props.navHeader}</div>
                        ) : null}
                        <Stack
                            isHorizontal={true}
                            alignItems='center'
                            justifyContent='space-between'
                        >
                            <Stack spacing={16}>
                                {renderAccent()}
                                <AiHomepageTitle text={props.title} />
                                <AiHomepageDescription text={props.subTitle} />
                                {props.action}
                            </Stack>
                            <div className={styles.illustration}>
                                <Illustration src={props.illustration} />
                            </div>
                        </Stack>
                    </KeyTriggeredAnimateIn>
                </div>
            </div>
        </Orbs>
    );
}
